import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  /* @import url("https://fonts.googleapis.com/css?family=Lato:300,400|Montserrat|Muli:400,600,900&display=swap"); */

  @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

*,
*::after,
*::before {
	margin: 0;
	padding: 0;
	box-sizing: inherit;
}

html {
	font-size: 62.5%;
	box-sizing: border-box;
}

  body {
    font-family: "Poppins", Helvetica, sans-serif;
    font-size: 1.8rem;
	  font-weight: 300;
    background: ${({ theme }) => theme.colors.body};
  }

  h2 {
    font-weight: 300;
    color: #55575c;
  }

  p {
    opacity: .6;
    line-height: 1.5;
  }

  img {
    max-width: 100%;
  }
  
  button {
    font-family: 'Lato', sans-serif;
    font-weight: 300;
  }


`;

export default GlobalStyles;
